import List from './actions/list';
import Find from './actions/find';
import Create from './actions/create';
import Delete from './actions/delete';
import Update from './actions/update';
import Resource from './resource';

export default class View extends Resource {
  get resourceName() {
    return 'view';
  }

  get resourcesName() {
    return 'views';
  }
}
// @ts-ignore
List.includeInto(View);
// @ts-ignore
Find.includeInto(View);
// @ts-ignore
Create.includeInto(View);
// @ts-ignore
Update.includeInto(View);
// @ts-ignore
Delete.includeInto(View);
